module.exports = __webpack_public_path__ + "img/approve-cancel-reservation.170841ff.svg";